import { ViewStyle } from 'react-native';
import { neutrals } from 'src/theme/colors';
import { ARROW_POSITION, ARROW_SIZE, MIN_DISTANCE } from '../Tooltip.constants';
import { TooltipPosition } from '../Tooltip.types';
import { TTooltipState } from './TooltipProvider.types';

const VISIBLE_Z_INDEX = 1000;
const HIDDEN_Z_INDEX = -1;

export function calculateTooltipAndArrowStyle(tooltipState: TTooltipState, screenWidth: number, screenHeight: number) {
  const { tooltip, layout, isVisible } = tooltipState;
  let tooltipStyle: ViewStyle = {
    position: 'absolute',
  };
  let arrowStyle: ViewStyle = {
    position: 'absolute',
  };

  if (!!tooltip && !!layout) {
    const {
      triggerLayout,
      backgroundColor = neutrals.white,
      width,
      height,
      position = TooltipPosition.BOTTOM,
      containerStyle,
    } = tooltip;

    tooltipStyle = {
      ...tooltipStyle,
      borderRadius: 12,
      shadowColor: `${neutrals.black}26`,
      shadowRadius: 40,
      shadowOffset: { width: 0, height: 0 },
      backgroundColor,
      width,
      height,
      zIndex: isVisible ? VISIBLE_Z_INDEX : HIDDEN_Z_INDEX,
    };

    const isArrowVisible = isVisible && tooltip.isArrowVisible;
    arrowStyle = {
      ...arrowStyle,
      width: 0,
      height: 0,
      borderStyle: 'solid',
      backgroundColor: 'transparent',
      zIndex: isArrowVisible ? VISIBLE_Z_INDEX : HIDDEN_Z_INDEX,
    };

    // --- POSITIONING LOGIC ---
    let left = 0;
    let right = 0;
    let top = 0;
    const currentArrowSize = isArrowVisible ? ARROW_SIZE : ARROW_SIZE / 2;

    switch (position) {
      case TooltipPosition.TOP:
        top = triggerLayout.y - layout.height - currentArrowSize;
        left = triggerLayout.x + (triggerLayout.width - layout.width) / 2;
        break;
      case TooltipPosition.BOTTOM:
        top = triggerLayout.y + triggerLayout.height + currentArrowSize;
        left = triggerLayout.x + (triggerLayout.width - layout.width) / 2;
        break;
      case TooltipPosition.LEFT:
        top = triggerLayout.y + (triggerLayout.height - layout.height) / 2;
        right = screenWidth - triggerLayout.x + triggerLayout.width + MIN_DISTANCE;
        break;
      case TooltipPosition.RIGHT:
        top = triggerLayout.y + (triggerLayout.height - layout.height) / 2;
        left = triggerLayout.x + triggerLayout.width + currentArrowSize;
        break;
    }

    // Check for screen boundaries and adjust if necessary
    if (left < MIN_DISTANCE) {
      left = MIN_DISTANCE;
    }

    if (right < MIN_DISTANCE) {
      right = MIN_DISTANCE;
    }

    if (top < MIN_DISTANCE) {
      top = MIN_DISTANCE;
    }

    if (left + layout.width > screenWidth - MIN_DISTANCE) {
      left = screenWidth - layout.width - MIN_DISTANCE;
    }
    if (top + layout.height > screenHeight - MIN_DISTANCE) {
      top = screenHeight - layout.height - MIN_DISTANCE;
    }

    if (right + layout.width > screenWidth - MIN_DISTANCE) {
      right = screenWidth - layout.width - MIN_DISTANCE;
    }

    tooltipStyle.top = top;
    if (position === TooltipPosition.LEFT) {
      tooltipStyle.right = right;
    } else {
      tooltipStyle.left = left;
    }

    tooltipStyle = { ...tooltipStyle, ...containerStyle };

    // ARROW STYLE

    if (isArrowVisible) {
      switch (position) {
        case TooltipPosition.TOP:
          arrowStyle.bottom = ARROW_POSITION;
          arrowStyle.left = triggerLayout.x + triggerLayout.width / 2 - (tooltipStyle.left as number)! - ARROW_SIZE;
          arrowStyle.borderTopWidth = currentArrowSize;
          arrowStyle.borderTopColor = backgroundColor;
          arrowStyle.borderLeftWidth = currentArrowSize;
          arrowStyle.borderLeftColor = 'transparent';
          arrowStyle.borderRightWidth = currentArrowSize;
          arrowStyle.borderRightColor = 'transparent';
          break;
        case TooltipPosition.BOTTOM:
          arrowStyle.top = ARROW_POSITION;
          arrowStyle.left =
            triggerLayout.x + triggerLayout.width / 2 - (tooltipStyle.left as number)! - currentArrowSize;
          arrowStyle.borderBottomWidth = currentArrowSize;
          arrowStyle.borderBottomColor = backgroundColor;
          arrowStyle.borderLeftWidth = currentArrowSize;
          arrowStyle.borderLeftColor = 'transparent';
          arrowStyle.borderRightWidth = currentArrowSize;
          arrowStyle.borderRightColor = 'transparent';
          break;
        case TooltipPosition.LEFT:
          arrowStyle.right = ARROW_POSITION;
          arrowStyle.top =
            triggerLayout.y + triggerLayout.height / 2 - (tooltipStyle.top as number)! - currentArrowSize;
          arrowStyle.borderLeftWidth = currentArrowSize;
          arrowStyle.borderLeftColor = backgroundColor;
          arrowStyle.borderTopWidth = currentArrowSize;
          arrowStyle.borderTopColor = 'transparent';
          arrowStyle.borderBottomWidth = currentArrowSize;
          arrowStyle.borderBottomColor = 'transparent';
          break;
        case TooltipPosition.RIGHT:
          arrowStyle.left = ARROW_POSITION;
          arrowStyle.top =
            triggerLayout.y + triggerLayout.height / 2 - (tooltipStyle.top as number)! - currentArrowSize;
          arrowStyle.borderRightWidth = currentArrowSize;
          arrowStyle.borderRightColor = backgroundColor;
          arrowStyle.borderTopWidth = currentArrowSize;
          arrowStyle.borderTopColor = 'transparent';
          arrowStyle.borderBottomWidth = currentArrowSize;
          arrowStyle.borderBottomColor = 'transparent';
          break;
      }
    }
  }
  return { tooltipStyle, arrowStyle };
}
